import axios from "axios";

export default axios.create({
    baseURL: 'https://lecastella.io/api.php'
});

export const axiosPrivate = axios.create({
    baseURL: 'https://lecastella.io/api.php',
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});

